import { Toggle } from '@statsbomb/kitbag-components';
import { useSetAtom } from 'jotai';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { messageReviewLibraryEntryActionAtom } from '../../atoms/messages';
import useApi, { API_ENDPOINTS } from '../../hooks/api';
import useVideoListings from '../../hooks/videoListings';
import { videoReferencePropTypes } from '../../types/videoReference';
import Confirm from '../Confirm';

export function ToggleDoNotUse({ isDoNotUse, videoReference }) {
  const api = useApi();
  const intl = useIntl();

  const [displayConfirmation, setDisplayConfirmation] = useState(false);
  const [requestedStatus, setRequestedStatus] = useState(isDoNotUse);

  const setReviewLibraryEntryMessage = useSetAtom(
    messageReviewLibraryEntryActionAtom,
  );

  const { refreshVideoSearchResults } = useVideoListings();

  const handleClick = () => setDisplayConfirmation(true);

  const handleCancel = () => setDisplayConfirmation(false);

  const toggleDoNotUse = async () => {
    setDisplayConfirmation(false);
    setReviewLibraryEntryMessage({
      text: intl.formatMessage({
        defaultMessage: 'Do not use change requested. Please wait',
        id: '48c67',
      }),
    });

    const { matchId, matchPart, sport, track, version } = videoReference;

    const response = await api.put(
      `${API_ENDPOINTS.videoService}/${sport}/${matchId}/${matchPart}/${track}/${version}/library-entry`,
      { data: {}, params: { do_not_use: !requestedStatus } },
    );
    if (response?.data) {
      setRequestedStatus((currentValue) => !currentValue);
      await refreshVideoSearchResults();
      setReviewLibraryEntryMessage(
        requestedStatus
          ? {
              text: intl.formatMessage({
                defaultMessage: 'Video made suitable for usage',
                id: 'e6815',
              }),
            }
          : {
              text: intl.formatMessage({
                defaultMessage:
                  'Video flagged as erroneous and unsuitable for usage',
                id: '64bb6',
              }),
            },
      );
    } else {
      setReviewLibraryEntryMessage({
        text: intl.formatMessage({
          defaultMessage:
            'Video do not use status change failed. Please try again',
          id: '0d33c',
        }),
        type: 'error',
      });
    }
  };
  return (
    <>
      <Toggle
        checked={requestedStatus}
        icon="Warning"
        onChange={handleClick}
        size="small"
      />
      <Confirm
        id={`videoaction.doNotUse.${JSON.stringify(videoReference)}`}
        isOpen={displayConfirmation}
        onCancel={handleCancel}
        onConfirm={toggleDoNotUse}
      >
        {requestedStatus ? (
          <FormattedMessage
            defaultMessage="This will ENABLE this video for use in our customer products. Are you sure?"
            id="82266"
          />
        ) : (
          <FormattedMessage
            defaultMessage="This will DISABLE this video for use in our customer products. Are you sure?"
            id="b00e2"
          />
        )}
      </Confirm>
    </>
  );
}

ToggleDoNotUse.propTypes = {
  isDoNotUse: PropTypes.bool.isRequired,
  videoReference: PropTypes.shape(videoReferencePropTypes).isRequired,
};

export default { ToggleDoNotUse };
